import CoursesScreen, {
  coursesRouteMarketProductsInitialParams,
  coursesRouteMarketProductCategoriesInitialParams,
} from 'components/screens/courses/courses-screen'
import { GetStaticProps } from 'next'
import React from 'react'
import { QueryClient, dehydrate } from 'react-query'
import getAllMarketProductCategoriesService, {
  QUERY_KEY as MARKET_PRODUCTS_CATEGORIES_QUERY_KEY,
} from 'services/market-product-category/get-all-market-product-categories-service'
import getAllMarketProductsService, {
  QUERY_KEY as MARKET_PRODUCTS_QUERY_KEY,
} from 'services/market-product/get-all-market-products-service'

export interface CoursesRouteProps {}

const CoursesRoute: React.FC<CoursesRouteProps> = ({}) => {
  return <CoursesScreen />
}

export default CoursesRoute

export const getStaticProps: GetStaticProps = async () => {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery(
    [MARKET_PRODUCTS_QUERY_KEY, coursesRouteMarketProductsInitialParams],
    () => getAllMarketProductsService(coursesRouteMarketProductsInitialParams)
  )

  await queryClient.prefetchQuery(
    [
      MARKET_PRODUCTS_CATEGORIES_QUERY_KEY,
      coursesRouteMarketProductCategoriesInitialParams,
    ],
    () =>
      getAllMarketProductCategoriesService(
        coursesRouteMarketProductCategoriesInitialParams
      )
  )

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: parseInt(process.env.NEXT_PUBLIC_ISR_REVALIDATE_TIME),
  }
}
